export type TContactContent = {
  subtitle: string;
  title: string;
  description: string;
  button: string;
};

const contactContent = {
  subtitle: "What's Next?",
  title: "Get In Touch",
  description:
    " Drop me a line if you think we'd make an awesome team! I'm always excited to collaborate with great people and have fun while creating something amazing. Whether you have a question or just want to say hello, I'll try my best to get back to you!",
  button: "Mail Me",
};

export default contactContent;
